import React from "react";
import { twMerge } from "tailwind-merge";

const Column = ({
  title,
  value,
  titleClass,
  valueClass,
  badge,
  badgeColor,
  waiting,
  center,
}) => (
  <p
    className={twMerge("flex flex-col gap-1 mx-auto", center && "items-center")}
  >
    <span
      className={twMerge("block text-[10px] text-purpleOverlay", titleClass)}
    >
      {title}
    </span>
    <span
      className={twMerge(
        "block font-medium text-purpleOverlay",
        badge &&
          "rounded-[13px] px-2.5 py-1 text-white text-[10px] font-normal",
        badgeColor === "orange" && "bg-orangeBg",
        badgeColor === "green" && "bg-[#4CB050]",
        badgeColor === "purple" && "bg-purpleBg",
        waiting && "text-gray-400 italic",
        valueClass
      )}
    >
      {!waiting ? value : "Waiting"}
    </span>
  </p>
);

const AppointmentItem = ({ title, date, time, assigned_to, status }) => {
  return (
    <div className="rounded-[10px] border border-gray-300 py-3 px-5 grid grid-cols-5">
      <Column title="Title" value={title} />
      <Column
        title="Date"
        value={date}
        waiting={status?.toLowerCase() === "requested"}
      />
      <Column
        title="Time"
        value={time}
        waiting={status?.toLowerCase() === "requested"}
      />
      <Column
        title="Assigned to"
        value={assigned_to}
        waiting={status?.toLowerCase() === "requested"}
      />
      <Column
        title="Status"
        value={status}
        center
        badge
        badgeColor={
          status?.toLowerCase() === "requested"
            ? "orange"
            : status?.toLowerCase() === "assigned"
            ? "green"
            : status?.toLowerCase() === "rescheduled" && "purple"
        }
      />
    </div>
  );
};

export default AppointmentItem;

export const appointmentList = [
  {
    title: "Youths Donations",
    date: "",
    time: "",
    assigned_to: "",
    status: "Requested",
  },
  {
    title: "Youths Donations",
    date: "23rd July 2024 ",
    time: "12:00pm",
    assigned_to: "Pastor Ayo",
    status: "Assigned",
  },
  {
    title: "Youths Donations",
    date: "23rd July 2024 ",
    time: "12:00pm",
    assigned_to: "Pastor Ayo",
    status: "Assigned",
  },
  {
    title: "Youths Donations",
    date: "23rd July 2024 ",
    time: "12:00pm",
    assigned_to: "Pastor Ayo",
    status: "Rescheduled",
  },
];
